const initTabsSlider = () => {
  const slider = document.querySelector('[data-slider="tabs"]');

  if (!slider) {
    return;
  }

  const swiper = new Swiper(slider, {
    slidesPerView: "auto",
    spaceBetween: 40,
    freeMode: true,
  });
};

export { initTabsSlider };
